import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const FEATURE_KEY = 'app';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface AppState {
  currentVersion?: string;
}

const initialState: AppState = {
  currentVersion: undefined,
};

const appSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setCurrentVersion: (state, action: PayloadAction<string>) => {
      state.currentVersion = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = appSlice.reducer;
const actions = appSlice.actions;

const state = (rootState: any): AppState => rootState[FEATURE_KEY];

const currentVersionSelector = createSelector(state, (state) => {
  return state.currentVersion;
});

export { actions, reducer, currentVersionSelector };
